import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import { Box, Button, FormGroup, CircularProgress } from '@mui/material';
import adminManagementService from '../../../services/AdminManagementService';
import { emptyAdminProfile } from '../fixtures';
import { Admin } from '../../../interfaces/Admin';
import { useTheme } from '@mui/material/styles';
import { getStyles } from '../styles';

function getModalStyle() {
    return {
        top: `37.5vh`,
        left: `37.5vw`,
    };
}

interface DeleteAdminModalProps {
    open: boolean;
    handleClose: (deleted?: boolean) => void;
    profile: Admin;
}

export default function DeleteAdminModal(props: DeleteAdminModalProps) {
    const theme = useTheme();
    const styles = getStyles(theme);
    const [modalStyle] = useState(getModalStyle);
    const [profile, setProfile] = useState<Admin>(emptyAdminProfile);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setProfile(props.profile);
    }, [props.profile]);

    const submitForm = async () => {
        setLoading(true);
        const success = await adminManagementService.deleteAdmin(profile.id!, profile.username);
        setLoading(false);
        if (success) props.handleClose(true);
    };

    return (
        <Modal
            aria-labelledby="admin-modal-title"
            aria-describedby="admin-modal-description"
            open={props.open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    props.handleClose();
                }
            }}
        >
            <Box sx={{ ...modalStyle, ...styles.paper }}>
                <h3 id="admin-modal-title">{ `You are about to permanently remove ${profile?.username || " "}!` }</h3>
                <br />
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    <Button variant="contained" sx={styles.btnDanger} onClick={submitForm}>Delete</Button>
                    <Button
                        variant="contained"
                        onClick={() => props.handleClose(false)}
                        sx={styles.ml2}>Close</Button>
                </FormGroup>
                {isLoading ? <CircularProgress color="primary" /> : undefined}
            </Box>
        </Modal>
    );
}